// @flow
import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  * {
    border: 0;
    box-sizing: inherit;
    -webkit-font-smoothing: antialiased;
    font-weight: inherit;
    margin: 0;
    outline: 0;
    padding: 0;
    text-rendering: optimizeLegibility;
    -webkit-appearance: none;
    -moz-appearance: none;
  }

  :root {
    --color-milk: #fff;
    --color-elephant-900: #12344D;
    --color-elephant-800: #264966;
    --color-elephant-700: #345C7C;
    --color-elephant-600: #447093;
    --color-smoke-700: #475867;
    --color-smoke-300: #92A2B1;
    --color-smoke-100: #CFD7DF;
    --color-smoke-50: #EBEFF3;
    --color-smoke-25: #F3F5F7;
    --color-jungle-800: #00795B;
    --color-jungle-500: #00A886;
    --color-jungle-100: #B4E5DA;
    --color-jungle-50: #E0F5F1;
    --color-azure-800: #2C5CC5;
    --color-azure-100: #BBDCFE;
    --color-azure-50: #E5F2FD;
    --color-persimmon-900: #C82124;
    --color-persimmon-800: #D72D30;
    --color-persimmon-100: #FFD0D6;
    --color-persimmon-50: #FFECF0;
    --color-casablanca-700: #E86F25;
    --color-casablanca-300: #F8AB59;
    --color-casablanca-100: #FEDCB3;
    --color-casablanca-50: #FEF1E1;
    --border-color: var(--color-smoke-100);
    --border-success-color: var(--color-jungle-100);
    --border-info-color: var(--color-azure-100);
    --border-danger-color: var(--color-persimmon-100);
    --border-warning-color: var(--color-casablanca-100);
    --bg-dark: var(--color-elephant-900);
    --bg-success: var(--color-jungle-50);
    --bg-info: var(--color-azure-50);
    --bg-danger: var(--color-persimmon-50);
    --bg-warning: var(--color-casablanca-50);
    --radius: 4px;
    --radius-small: 2px;
     --base-color: #11344d;
    --secondary-color: #6f7c87;
    --font-stack: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
    --font-weight-400: 400;
    --font-weight-300: 300;
    --font-weight-500: 500;
    --font-weight-600: 600;
    --font-weight-700: 700;
    --font-size-10: 10px;
    --font-size-12: 12px;
    --font-size-14: 14px;
    --font-size-16: 16px;
    --font-size-18: 18px;
    --font-size-20: 20px;
    --font-size-24: 24px;
    --text-default: var(--color-elephant-900);
    --text-secondary: var(--color-smoke-700);
    --text-disabled: var(--color-smoke-300);
    --text-success: var(--color-jungle-800);
    --text-info: var(--color-azure-800);
    --text-danger: var(--color-persimmon-800);
    --text-warning: var(--color-casablanca-700);
    --text-link: var(--color-azure-800);
    --icon-primary: var(--color-smoke-700);
    --icon-primary-hover: var(--color-smoke-100);
    --color-brand: #149999;
  }

  html {
    display: flex;
    height: 100%;
    width: 100%;
    max-height: 100%;
    max-width: 100%;
    box-sizing: border-box;
    font-size: 16px;
    line-height: 1.5;
    background-color: #ebeef0;
    color: #16171a;
    padding: 0;
    margin: 0;
    -webkit-font-smoothing: antialiased;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial,
      sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
  }

  body {
    display: flex;
    box-sizing: border-box;
    flex: auto;
    align-self: stretch;
    max-width: 100%;
    max-height: 100%;
    -webkit-overflow-scrolling: touch;
  }

  a {
    color: currentColor;
    text-decoration: none;
  }

  a:hover {
    color: #283da5;
    cursor: pointer;
  }

  textarea {
    resize: none;
  }

  ::-moz-selection {
    /* Code for Firefox */
    background: rgba(125, 188, 255, 0.6);
    color: #333;
  }

  ::selection {
    background: rgba(125, 188, 255, 0.6);
    color: #333;
  }

  ::-webkit-input-placeholder {
    /* WebKit, Blink, Edge */
    color: #a3afbf;
  }
  :-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #a3afbf;
    opacity: 1;
  }
  ::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #a3afbf;
    opacity: 1;
  }
  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #a3afbf;
  }

  #root {
    display: flex;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flexbox;
    flex-direction: column;
    -ms-flex-direction: column;
    -moz-flex-direction: column;
    -webkit-flex-direction: column;
    height: 100%;
    width: 100%;
  }

  .fade-enter {
    opacity: 0;
    z-index: 1;
  }

  .fade-enter.fade-enter-active {
    opacity: 1;
    transition: opacity 250ms ease-in;
  }

  .bp3-transition-container {
    z-index: 600!important;
  }

  a[href]:hover {
    text-decoration: none;
  }
  .Toastify__toast-container {
    z-index: 9999;
    position: fixed;
    padding: 4px;
    width: 320px;
    box-sizing: border-box;
    color: #fff; }
    .Toastify__toast-container--top-left {
      top: 1em;
      left: 1em; }
    .Toastify__toast-container--top-center {
      top: 1em;
      left: 50%;
      margin-left: -160px; }
    .Toastify__toast-container--top-right {
      top: 1em;
      right: 1em; }
    .Toastify__toast-container--bottom-left {
      bottom: 1em;
      left: 1em; }
    .Toastify__toast-container--bottom-center {
      bottom: 1em;
      left: 50%;
      margin-left: -160px; }
    .Toastify__toast-container--bottom-right {
      bottom: 1em;
      right: 1em; }
  
  @media only screen and (max-width: 480px) {
    .Toastify__toast-container {
      width: 100vw;
      padding: 0;
      left: 0;
      margin: 0; }
      .Toastify__toast-container--top-left, .Toastify__toast-container--top-center, .Toastify__toast-container--top-right {
        top: 0; }
      .Toastify__toast-container--bottom-left, .Toastify__toast-container--bottom-center, .Toastify__toast-container--bottom-right {
        bottom: 0; }
      .Toastify__toast-container--rtl {
        right: 0;
        left: initial; } }
  
  .Toastify__toast {
    position: relative;
    min-height: 64px;
    padding: 0;
    background: #fff;
    color: #222;
    box-sizing: border-box;
    margin-bottom: 1rem;
    border-radius: 1px;
    box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.1), 0 2px 15px 0 rgba(0, 0, 0, 0.05);
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: justify;
    justify-content: space-between;
    max-height: 800px;
    overflow: hidden;
    cursor: pointer;
    direction: ltr; }
    .Toastify__toast--rtl {
      direction: rtl; }
    .Toastify__toast--default {
      background: #fff;
      color: #aaa; }
    .Toastify__toast--info .icon-wrapper {
      background: #ffad1e; }
    .Toastify__toast--success .icon-wrapper {
      background: #02b875; }
    .Toastify__toast--warning .icon-wrapper {
      background: #ffad1e; }
    .Toastify__toast--error .icon-wrapper {
      background: #ff5959; }
    .Toastify__toast-body {
      height: 100%;
      min-height: 64px;
      flex: 1; }
  
  @media only screen and (max-width: 480px) {
    .Toastify__toast {
      margin-bottom: 0; } }
  
  .Toastify__close-button {
    color: #fff;
    font-weight: bold;
    font-size: 14px;
    background: transparent;
    outline: none;
    border: none;
    padding: 0;
    cursor: pointer;
    opacity: 0.7;
    transition: 0.3s ease;
    -ms-flex-item-align: start;
        align-self: flex-start; }
    .Toastify__close-button--default {
      color: #000;
      opacity: 0.3; }
    .Toastify__close-button:hover, .Toastify__close-button:focus {
      opacity: 1; }
  
  @keyframes Toastify__trackProgress {
    0% {
      transform: scaleX(1); }
    100% {
      transform: scaleX(0); } }
  
  .Toastify__progress-bar {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 5px;
    z-index: 9999;
    opacity: 0.7;
    background-color: rgba(255, 255, 255, 0.7);
    transform-origin: left; }
    .Toastify__progress-bar--animated {
      animation: Toastify__trackProgress linear 1 forwards; }
    .Toastify__progress-bar--controlled {
      transition: transform .2s; }
    .Toastify__progress-bar--rtl {
      right: 0;
      left: initial;
      transform-origin: right; }
    .Toastify__progress-bar--default {
      background: linear-gradient(to right, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55); }
  
  @keyframes Toastify__bounceInRight {
    from,
    60%,
    75%,
    90%,
    to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1); }
    from {
      opacity: 0;
      transform: translate3d(3000px, 0, 0); }
    60% {
      opacity: 1;
      transform: translate3d(-25px, 0, 0); }
    75% {
      transform: translate3d(10px, 0, 0); }
    90% {
      transform: translate3d(-5px, 0, 0); }
    to {
      transform: none; } }
  
  @keyframes Toastify__bounceOutRight {
    20% {
      opacity: 1;
      transform: translate3d(-20px, 0, 0); }
    to {
      opacity: 0;
      transform: translate3d(2000px, 0, 0); } }
  
  @keyframes Toastify__bounceInLeft {
    from,
    60%,
    75%,
    90%,
    to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1); }
    0% {
      opacity: 0;
      transform: translate3d(-3000px, 0, 0); }
    60% {
      opacity: 1;
      transform: translate3d(25px, 0, 0); }
    75% {
      transform: translate3d(-10px, 0, 0); }
    90% {
      transform: translate3d(5px, 0, 0); }
    to {
      transform: none; } }
  
  @keyframes Toastify__bounceOutLeft {
    20% {
      opacity: 1;
      transform: translate3d(20px, 0, 0); }
    to {
      opacity: 0;
      transform: translate3d(-2000px, 0, 0); } }
  
  @keyframes Toastify__bounceInUp {
    from,
    60%,
    75%,
    90%,
    to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1); }
    from {
      opacity: 0;
      transform: translate3d(0, 3000px, 0); }
    60% {
      opacity: 1;
      transform: translate3d(0, -20px, 0); }
    75% {
      transform: translate3d(0, 10px, 0); }
    90% {
      transform: translate3d(0, -5px, 0); }
    to {
      transform: translate3d(0, 0, 0); } }
  
  @keyframes Toastify__bounceOutUp {
    20% {
      transform: translate3d(0, -10px, 0); }
    40%,
    45% {
      opacity: 1;
      transform: translate3d(0, 20px, 0); }
    to {
      opacity: 0;
      transform: translate3d(0, -2000px, 0); } }
  
  @keyframes Toastify__bounceInDown {
    from,
    60%,
    75%,
    90%,
    to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1); }
    0% {
      opacity: 0;
      transform: translate3d(0, -3000px, 0); }
    60% {
      opacity: 1;
      transform: translate3d(0, 25px, 0); }
    75% {
      transform: translate3d(0, -10px, 0); }
    90% {
      transform: translate3d(0, 5px, 0); }
    to {
      transform: none; } }
  
  @keyframes Toastify__bounceOutDown {
    20% {
      transform: translate3d(0, 10px, 0); }
    40%,
    45% {
      opacity: 1;
      transform: translate3d(0, -20px, 0); }
    to {
      opacity: 0;
      transform: translate3d(0, 2000px, 0); } }
  
  .Toastify__bounce-enter--top-left, .Toastify__bounce-enter--bottom-left {
    animation-name: Toastify__bounceInLeft; }
  
  .Toastify__bounce-enter--top-right, .Toastify__bounce-enter--bottom-right {
    animation-name: Toastify__bounceInRight; }
  
  .Toastify__bounce-enter--top-center {
    animation-name: Toastify__bounceInDown; }
  
  .Toastify__bounce-enter--bottom-center {
    animation-name: Toastify__bounceInUp; }
  
  .Toastify__bounce-exit--top-left, .Toastify__bounce-exit--bottom-left {
    animation-name: Toastify__bounceOutLeft; }
  
  .Toastify__bounce-exit--top-right, .Toastify__bounce-exit--bottom-right {
    animation-name: Toastify__bounceOutRight; }
  
  .Toastify__bounce-exit--top-center {
    animation-name: Toastify__bounceOutUp; }
  
  .Toastify__bounce-exit--bottom-center {
    animation-name: Toastify__bounceOutDown; }
  
  @keyframes Toastify__zoomIn {
    from {
      opacity: 0;
      transform: scale3d(0.3, 0.3, 0.3); }
    50% {
      opacity: 1; } }
  
  @keyframes Toastify__zoomOut {
    from {
      opacity: 1; }
    50% {
      opacity: 0;
      transform: scale3d(0.3, 0.3, 0.3); }
    to {
      opacity: 0; } }
  
  .Toastify__zoom-enter {
    animation-name: Toastify__zoomIn; }
  
  .Toastify__zoom-exit {
    animation-name: Toastify__zoomOut; }
  
  @keyframes Toastify__flipIn {
    from {
      transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
      animation-timing-function: ease-in;
      opacity: 0; }
    40% {
      transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
      animation-timing-function: ease-in; }
    60% {
      transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
      opacity: 1; }
    80% {
      transform: perspective(400px) rotate3d(1, 0, 0, -5deg); }
    to {
      transform: perspective(400px); } }
  
  @keyframes Toastify__flipOut {
    from {
      transform: perspective(400px); }
    30% {
      transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
      opacity: 1; }
    to {
      transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
      opacity: 0; } }
  
  .Toastify__flip-enter {
    animation-name: Toastify__flipIn; }
  
  .Toastify__flip-exit {
    animation-name: Toastify__flipOut; }
  
  @keyframes Toastify__slideInRight {
    from {
      transform: translate3d(110%, 0, 0);
      visibility: visible; }
    to {
      transform: translate3d(0, 0, 0); } }
  
  @keyframes Toastify__slideInLeft {
    from {
      transform: translate3d(-110%, 0, 0);
      visibility: visible; }
    to {
      transform: translate3d(0, 0, 0); } }
  
  @keyframes Toastify__slideInUp {
    from {
      transform: translate3d(0, 110%, 0);
      visibility: visible; }
    to {
      transform: translate3d(0, 0, 0); } }
  
  @keyframes Toastify__slideInDown {
    from {
      transform: translate3d(0, -110%, 0);
      visibility: visible; }
    to {
      transform: translate3d(0, 0, 0); } }
  
  @keyframes Toastify__slideOutRight {
    from {
      transform: translate3d(0, 0, 0); }
    to {
      visibility: hidden;
      transform: translate3d(110%, 0, 0); } }
  
  @keyframes Toastify__slideOutLeft {
    from {
      transform: translate3d(0, 0, 0); }
    to {
      visibility: hidden;
      transform: translate3d(-110%, 0, 0); } }
  
  @keyframes Toastify__slideOutDown {
    from {
      transform: translate3d(0, 0, 0); }
    to {
      visibility: hidden;
      transform: translate3d(0, 500px, 0); } }
  
  @keyframes Toastify__slideOutUp {
    from {
      transform: translate3d(0, 0, 0); }
    to {
      visibility: hidden;
      transform: translate3d(0, -500px, 0); } }
  
  .Toastify__slide-enter--top-left, .Toastify__slide-enter--bottom-left {
    animation-name: Toastify__slideInLeft; }
  
  .Toastify__slide-enter--top-right, .Toastify__slide-enter--bottom-right {
    animation-name: Toastify__slideInRight; }
  
  .Toastify__slide-enter--top-center {
    animation-name: Toastify__slideInDown; }
  
  .Toastify__slide-enter--bottom-center {
    animation-name: Toastify__slideInUp; }
  
  .Toastify__slide-exit--top-left, .Toastify__slide-exit--bottom-left {
    animation-name: Toastify__slideOutLeft; }
  
  .Toastify__slide-exit--top-right, .Toastify__slide-exit--bottom-right {
    animation-name: Toastify__slideOutRight; }
  
  .Toastify__slide-exit--top-center {
    animation-name: Toastify__slideOutUp; }
  
  .Toastify__slide-exit--bottom-center {
    animation-name: Toastify__slideOutDown; }
  button {
    outline: 0!important;
  }  
  .bp3-input-group .bp3-input,
    box-shadow: none;
    border: 1px solid #eaeaea;
  }
  .bp3-input-group .bp3-input:focus,
  .bp3-input-group .bp3-input.bp3-active {
    box-shadow: none;
    border: 1px solid #999;
  }
  .bp3-datepicker .DayPicker-Day.DayPicker-Day--selected {
    background-color: #7e7efc!important;
  }
  .PhoneInputInput {
    font-weight: 600;
    font-size: 13px;
    opacity: 0.6;
  }
  .PhoneInputInput:focus {
    outline: none;
  }
  .customcountrylist__ul {
    width: 100%;
    left: 0px;
    top: 42px;
    background-color: white;
    z-index: 10;
    position: absolute;
    max-height: 180px;
    list-style: none;
    overflow: auto;
    cursor: pointer;
    border-radius : 3px;
    box-shadow: 0 6px 12px rgba(0,0,0,0.05), 0 1px 4px rgba(0,0,0,0.15);
    padding : 5px;
    font-size : 14px;
    font-weight : 400;
  }
  .customcountrylist__li {
    height: 30px;
    border : none;
    padding: 5px 8px;
  }
  .customcountrylist__li:hover {
    background-color: #f5f5f5;
  }
  .customcountry__icon {
    display: flex;
    padding-right: 10px;
    cursor: pointer;
    align-items: center;
    background-color : transparent;
  }

  #create-incident {
    z-index: 10;
  }

  .tippy-popper[x-placement^=right] [data-animation=shift].enter {
      opacity: 1;
      -webkit-transform: translateX(10px);
      transform: translateX(10px);
  }

  .tippy-popper[x-placement^=right] [data-animation=shift].leave {
      opacity: 0;
      -webkit-transform: translateX(0);
      transform: translateX(0);
  }
  
  .tippy-popper[x-placement^=top] [data-animation=shift].enter {
    opacity: 1;
    -webkit-transform: translateY(-10px);
    transform: translateY(-10px)
  }

  .tippy-popper[x-placement^=top] [data-animation=shift].leave {
    opacity: 0;
    -webkit-transform: translateY(0);
    transform: translateY(0)
  }

  .tippy-popper[x-placement^=bottom] [data-animation=shift].enter {
    opacity: 1;
    -webkit-transform: translateY(10px);
    transform: translateY(10px)
  }

  .tippy-popper[x-placement^=bottom] [data-animation=shift].leave {
    opacity: 0;
    -webkit-transform: translateY(0);
    transform: translateY(0)
  }

  .tippy-popper[x-placement^=left] [data-animation=shift].enter {
    opacity: 1;
    -webkit-transform: translateX(-10px);
    transform: translateX(-10px)
  }

  .tippy-popper[x-placement^=left] [data-animation=shift].leave {
    opacity: 0;
    -webkit-transform: translateX(0);
    transform: translateX(0)
  }

  .hide-timepicker {
    display: none;
  }

  .freshworks-omnibar-event-target {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 65px;
    height: 65px;
    z-index: +1000;
  }

  .freshworks-omnibar-event-target > div > div {
    position: fixed !important;
    bottom: 20px !important;
  }

  label {
    text-transform: initial !important;
  }

  body div#fc_frame,
  body div.fc-widget-small,
  body div#freshworks-container {
    z-index: 10 !important;
  }

  body div#freshworks-container iframe {
    z-index: inherit !important;
  }

  body iframe#launcher-frame {
    bottom: 48px !important;
    min-width: 88px !important;
    max-width: 88px !important;
  }
`;
